module.exports = __webpack_public_path__ + "img/bigyoshi.12680b1b.png";